import React from 'react'
import Tooltip from '@material-ui/core/Tooltip';
import AcUnitIcon from '@material-ui/icons/AcUnit';
import { withStyles } from '@material-ui/core/styles';

const styles = {
    container: {
        display: "contents",
    },
    currentFreezeIcon:{
        color: "#1976d2",
        marginBottom: "-4px",
        marginLeft: "5px",
        marginRight: "5px",
    },
    pastFreezeIcon:{
        color: "rgba(0, 0, 0, 0.54)",
        marginBottom: "-4px",
    },
};

const FreezeIcons = ({ classes, past_fe_dict, current_fe_dict }) => {
    return (
        <>
        {current_fe_dict['exists']&&
            <Tooltip title={"Freeze event ongoing on " + current_fe_dict['node'] + (current_fe_dict['multiple'] ? ' and others' : '')}>
                <AcUnitIcon className={classes.currentFreezeIcon}/>
            </Tooltip>}
        {past_fe_dict['exists'] &&
            <Tooltip title={"Last freeze event on " + past_fe_dict['node'] + " completed at " + past_fe_dict['time'] + (past_fe_dict['multiple'] ? ' and others' : '')}>
                <AcUnitIcon className={classes.pastFreezeIcon}/>
            </Tooltip>}
        </>
    )
}

export default withStyles(styles)(FreezeIcons);
